
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cp8J5", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.edc224ab.js.map
